// src/lib/utils.ts
import {clsx, type ClassValue} from "clsx"
import {twMerge} from "tailwind-merge"

/** Merge conditional class names + resolve Tailwind conflicts */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format an ISO date string (YYYY-MM-DD) to localized date string
 * without timezone conversion issues.
 *
 * @param isoDate - ISO date string (e.g., "2025-01-22")
 * @param options - Intl.DateTimeFormat options
 * @returns Formatted date string
 */
export function formatLocalDate(
  isoDate: string,
  options?: Intl.DateTimeFormatOptions
): string {
  if (!isoDate) return ''

  // Parse date components manually to avoid timezone issues
  const [year, month, day] = isoDate.split('-').map(Number)

  // Create date in local timezone (month is 0-indexed)
  const date = new Date(year, month - 1, day)

  if (isNaN(date.getTime())) return ''

  return date.toLocaleDateString('en-US', options || {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  })
}
